import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import ErrorMask from 'components/masks/ErrorMask';
import { Row } from 'components/Containers/Row/Row';

const ActionError = ({ datatestid, error, homePageHandler }) => {
  return (
    <div>
      <SectionContainer>
        <Row>
          <ErrorMask
            title="Sorry there was an error."
            message={error.error}
            buttonLabel="Back to actions."
            onClick={homePageHandler}
          />
        </Row>
      </SectionContainer>
    </div>
  );
};

export default ActionError;
